module.exports = __webpack_public_path__ + "static/img/2-22-已创建手工售后单.6ed8122.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/ppt/2-22-已创建手工售后单.png
// module id = 1358
// module chunks = 0